<template>
    <div class="m-panel">
        <div class="m-panel-bar">
            <div class="m-panel-bar-title">
            {{title}}
            </div>
        </div>
        <div class="m-panel-body">
            <Echart :options="option" style="height: 100%"></Echart>
        </div>
    </div>
</template>
<script>
import echarts from 'echarts/lib/echarts';
import { getAction } from '@/api/manage'
export default {
    props: {
            titleImage: {
            type: String,
            default: ''
        },
    },
    data() {
        return{
            title: this.$t('压力'),
            option: {},
            lowPressLinevalue: 0,
            heightPressLinevalue: 0,
            url:{
                PWOnTimeRecord:"/jeecg-charge/wq/partPWMeterdatarecord/list"
            },
            PWOnTimeRecord:[],
        }
    },
    mounted() {
    },
    methods: {
        init() {
            this.resetData()
            this.queryPWOnTimeRecord()
        },
        resetData() {
            this.option = this.$options.data.call(this).option
        },
        queryPWOnTimeRecord() {
            let params = {deviceType: 'PM'}
            getAction(this.url.PWOnTimeRecord, params).then((res) => {
                if(res.success&&res.result.records.length>0){
                    this.PWOnTimeRecord = res.result.records[0];
                    console.log(this.PWOnTimeRecord);
                    let data = {
                    deviceLocation: this.PWOnTimeRecord.deviceLocation,
                    tempValue: this.PWOnTimeRecord.tepvalue
                    }
                    this.lowPressLinevalue = this.PWOnTimeRecord.pvalueLow
                    this.heightPressLinevalue = this.PWOnTimeRecord.pvalueTop
                    console.log(this.lowPressLinevalue);
                    this.setOption(data)
                }else{
                    this.PWOnTimeRecord.pvalue = 2.2
                    let data = {
                        deviceLocation: '小寨',
                        tempValue: 23
                    }
                    this.setOption(data)
                }
            }) 
        },
        setOption(data) {
            let min = 0;
            let max = 2.5;
            this.option = {
                //backgroundColor: "#062a44",
                series: [
                    {
                        name: this.$t('压力'),
                        type: 'gauge',
                        radius: '75%',
                        min: 0,
                        max: 2.5,
                        startAngle: 180,
                        endAngle: 0,
                        splitNumber: 5,
                        axisLine: {
                            show: false,
                            lineStyle: {
                                width: 1,
                                color: [
                                    [1, 'rgba(0,0,0,0)']
                                ]
                            }
                        }, //仪表盘轴线
                        axisLabel: {
                            show: true,
                            color: '#ffffff',
                            fontWeight: 500,
                            fontSize: 16,
                            shadowOffsetY: 20,
                            distance: 8,
                            formatter: function(params) {
                                if(params == min||params == max) {
                                    return params
                                }
                            }
                        }, //刻度标签。
                        axisTick: {
                            show: true,
                            splitNumber: 5,
                            lineStyle: {
                                color: '#5B87C3',
                                width: 2
                            },
                            length: -20
                        }, //刻度样式
                        splitLine: {
                            show: false,
                            length: 5,
                            lineStyle: {
                                color: '#5B87C3'
                            }
                        }, //分隔线样式
                        detail: {
                            show: false
                        },
                        pointer: {
                            show: false
                        }
                    },
                    {
                        type: 'gauge',
                        name: this.$t('压力'),
                        radius: '70%',
                        center: ['50%', '50%'],
                        startAngle: 180,
                        endAngle: 0,
                        min: 0,
                        max: 2.5,
                        animationDelay: 2000,
                        animationDuration: 2000,
                        animationEasing: 'bounceInOut',
                        axisLine: {
                            lineStyle: {
                                color: [[this.lowPressLinevalue/2.5, '#FFA500'],[this.heightPressLinevalue/2.5, '#00FAFE'],[1, '#FF4240']],
                                width: 3
                            }
                        },
                        //分隔线样式。
                        splitLine: {
                            show: false,
                        },
                        axisLabel: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        pointer: {
                            show: true,
                            length: '50%',
                            width: 4
                        },
                        //仪表盘详情，用于显示数据。
                        detail: {
                            show: true,
                            offsetCenter: ['0%', '85%'],
                            //color: '#ddd',
                            formatter: (params) => {
                                return `{normal|${this.$t('压力值')}:}{ds|${params}}{normal|MPa}\n{sub|${this.$t('温度值')}:${data.tempValue}℃\n${this.$t('安装位置')}:${data.deviceLocation}}`
                            },
                            textStyle: {
                                rich: {
                                    ds: {
                                        fontFamily: 'ds-digital-bold',
                                        fontSize: 20,
                                    },
                                    normal: {
                                        fontSize: 12
                                    },
                                    sub: {
                                        fontSize: 12,
                                        color: '#6ED9F2'
                                    }
                                }
                            }
                        },
                        data: [{
                            value: this.PWOnTimeRecord.pvalue
                        }]
                    }
                ]
            };
        }
    }
}
</script>